import type { Hero } from '../types';

export interface RecommendationSortable {
  winRateDelta: number;
  hero: Pick<Hero, 'id'>;
}

/**
 * 推薦の並び: Δ 降順、同率は hero.id 昇順（SMART_DRAFT_RECOMMENDATION §3.2）
 */
export function compareRecommendationByDeltaDesc(
  a: RecommendationSortable,
  b: RecommendationSortable
): number {
  if (b.winRateDelta !== a.winRateDelta) {
    return b.winRateDelta - a.winRateDelta;
  }
  return a.hero.id - b.hero.id;
}
